import { api } from '@/lib/utils'
import { User as UserType } from '@/types'

export const endpoints = {
  signup: (site: string) => `/${site}/accounts/signup/`
}

interface SignupUserData extends UserType {
  confirmPassword?: string
  taxDocument?: string
  birthdate?: string
  phoneNumber?: string
  postcode?: string
  line1?: string
  line2?: string
  line3?: string
  line4?: string
  city?: string
  stateCode?: string
}

export const signup = ({
  site,
  channel,
  userData,
  policies
}: {
  site: string
  channel?: string
  userData: SignupUserData
  policies?: string[]
}) => {
  const config = {
    method: 'post',
    url: endpoints.signup(site),
    data: {
      ...userData,
      ...(channel ? { channel: decodeURIComponent(channel) } : {}),
      ...(policies?.length ? { policies } : {})
    }
  }
  return api(config)
}
